var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as jsjoda from '@js-joda/core';
import { delay, forever } from './promise';
const __request = (url, m, c) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield fetch(url, Object.assign(Object.assign({}, (c || {})), { 'headers': new Headers(Object.assign(Object.assign({}, c === null || c === void 0 ? void 0 : c.headers), { 'Authorization': `Bearer ${window.localStorage.getItem('token')}` })) }));
        const status = response.status;
        const error = () => {
            console.error(`_request.error - ${url}: ${response.status}`);
            return forever();
        };
        switch (status) {
            case 200:
                return m[status](response);
            case 401:
                window.localStorage.clear();
                window.location.reload();
                return forever();
            case 400:
            case 404:
            case 422:
            case 500:
                return m && m[status] ? m[status](response) : error();
            default:
                console.error(`_request.error - ${url}: ${response.status}`);
                return forever();
        }
    }
    catch (e) {
        if (e.name === 'AbortError') {
            console.info(`_request.aborted - ${url}`);
        }
        else {
            console.error(e);
        }
        return forever();
    }
});
export const getConst = (x) => (_c, m) => m({ 200: () => __awaiter(void 0, void 0, void 0, function* () { return x; }) })[200]();
export const getJson = (url) => (c, m) => __request(url, m({ 200: (r) => r.json() }), c({}));
function stringifier(k, v) {
    if (this[k] instanceof jsjoda.LocalDate) {
        return this[k].format(jsjoda.DateTimeFormatter.ofPattern('yyyy-MM-dd'));
    }
    if (this[k] instanceof jsjoda.LocalTime) {
        return this[k].format(jsjoda.DateTimeFormatter.ofPattern('HH:mm:ss'));
    }
    if (this[k] instanceof jsjoda.LocalDateTime) {
        return this[k].format(jsjoda.DateTimeFormatter.ofPattern('yyyy-MM-dd HH:mm:ss'));
    }
    return v;
}
export const postJson = (url, body) => (c, m) => __request(url, m({ 200: (r) => r.json() }), c({ 'method': 'POST', 'body': JSON.stringify(body, stringifier) }));
export const deleteJson = (url, body) => (c, m) => __request(url, m({ 200: (r) => r.json() }), c({ 'method': 'DELETE', 'body': JSON.stringify(body, stringifier) }));
export const withDone = (r) => () => {
    return r((x) => x, (x) => x);
};
export const withMap = (r, f) => (c, m) => r(c, (m2) => m({
    200: (x) => __awaiter(void 0, void 0, void 0, function* () { return f(yield m2[200](x)); }),
}));
export const withDelay = (n, f) => (c, m) => f(c, (m2) => m({
    200: (x) => __awaiter(void 0, void 0, void 0, function* () { yield delay(n); return m2[200](x); }),
}));
export const withAbort = (f) => {
    const controller = new AbortController();
    return [(c, m) => f((x) => c(Object.assign(Object.assign({}, x), { 'signal': controller.signal })), m), () => { controller.abort(); }];
};
export const withValidate = (f) => (c, m) => f(c, (m2) => m({
    200: (x) => __awaiter(void 0, void 0, void 0, function* () { return [true, yield m2[200](x)]; }),
    422: (x) => __awaiter(void 0, void 0, void 0, function* () { return [false, yield x.json()]; }),
}));
export const withOptional = (f) => {
    return (c, m) => f(c, (m2) => m(Object.assign(Object.assign({}, m2), { 404: (_) => __awaiter(void 0, void 0, void 0, function* () { return null; }) })));
};
